import { lazy, Suspense } from "react";
import { Layout } from "@/components/layout/Layout";
import { HeroSection } from "@/components/home/HeroSection";
import { PageSEO } from "@/components/PageSEO";

const FishCategories = lazy(() => import("@/components/home/FishCategories").then(m => ({ default: m.FishCategories })));
const FeaturedProducts = lazy(() => import("@/components/home/FeaturedProducts").then(m => ({ default: m.FeaturedProducts })));
const CategorySection = lazy(() => import("@/components/home/CategorySection").then(m => ({ default: m.CategorySection })));
const ServicesPreview = lazy(() => import("@/components/home/ServicesPreview").then(m => ({ default: m.ServicesPreview })));
const B2BSection = lazy(() => import("@/components/home/B2BSection").then(m => ({ default: m.B2BSection })));
const MoreToLove = lazy(() => import("@/components/home/MoreToLove").then(m => ({ default: m.MoreToLove })));
const CTASection = lazy(() => import("@/components/home/CTASection").then(m => ({ default: m.CTASection })));
const PopupBanner = lazy(() => import("@/components/home/PopupBanner").then(m => ({ default: m.PopupBanner })));

const Index = () => {
  return (
    <Layout>
      <PageSEO
        title="Oyanishikigoi — Premium Japanese Koi Fish in Sri Lanka"
        description="Shop premium Nishikigoi, aquarium supplies, and expert pond services from Sri Lanka's most trusted koi destination."
        path="/"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Oyanishikigoi",
            url: "https://www.oya-nishikigoi.com/",
            logo: "https://www.oya-nishikigoi.com/apple-touch-icon-20260416s.png",
            sameAs: [],
          },
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "Oyanishikigoi",
            url: "https://www.oya-nishikigoi.com/",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://www.oya-nishikigoi.com/shop?search={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          },
        ]}
      />
      <Suspense fallback={null}>
        <PopupBanner />
      </Suspense>
      <HeroSection />
      <Suspense fallback={<div className="min-h-[200px]" />}>
        <FishCategories />
        <FeaturedProducts />
        <CategorySection />
        <ServicesPreview />
        <B2BSection />
        <MoreToLove />
        <CTASection />
      </Suspense>
    </Layout>
  );
};

export default Index;
